import { useSearchParams } from 'react-router-dom';

export const useQueryParam = (name: string, defaultValue: string = '') => {
  const [searchParams] = useSearchParams();
  return searchParams.get(name) ?? defaultValue;
};
